export default {
    name: 'footer',
    component() {
        return {
            newsletter: {
                email: "",
                success: false,
            },
            emailError: false,

            init() {
                const subscribeSuccess = new URLSearchParams(window.location.search).get('customer_posted');
                const alreadySubscribed = new URLSearchParams(window.location.search).has('contact[tags]');

                if (alreadySubscribed) {
                  this.newsletter.success = true;                  
                }
            },
            
            validateNewsletter() {
                let valid = true;
        
                if (
                    this.newsletter.email !== "" &&
                    this.validateEmail(this.newsletter.email)
                ) {

                } else {
                    if(this.newsletter.email == "" || this.validateEmail(this.newsletter.email) == null) {
                        this.emailError = true;
                    } else {
                        this.emailError = false;
                    }

                    valid = false;
                }
        
                if (valid) {
                    this.submitNewsletter();
                }
            },

            submitNewsletter() {
              setTimeout(() => {
                  this.newsletter.success = true;
              }, "500");

               const form = this.$root.querySelector("form[id='contact_form']");
               form.submit();
            },

            validateEmail(email) {
              return String(email)
                  .toLowerCase()
                  .match(
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                  );
            },
        }
    }
}